import { render, staticRenderFns } from "./atualizacoes.vue?vue&type=template&id=26fc7155&"
import script from "./atualizacoes.vue?vue&type=script&lang=js&"
export * from "./atualizacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports